<template>
  <v-app>
    <v-snackbar
      v-model="snackbar.showing"
      top
      center
      :color="snackbar.type"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
    </v-snackbar>

    <v-progress-circular
      v-if="isLoading || isBooting"
      class="loader-page"
      indeterminate
      color="primary"
      :size="50"
      :width="5"
    />
    <template v-else>
      <AppHeader v-if="isAuthenticated && !$route.meta.hideMenu" />
      <router-view />
      <CookiesSnackbar v-if="isAuthenticated && !isBooting" />
    </template>
  </v-app>
</template>

<script>
import checkBrowser from '@/helpers/checkBrowser'
import CookiesSnackbar from '@/components/CookiesSnackbar.vue'
import AppHeader from '@/components/AppHeader.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import { loadLanguage } from '@/plugins/i18n'

export default {
  name: 'App',

  components: {
    AppHeader,
    CookiesSnackbar
  },

  data() {
    return {
      isLoading: true
    }
  },

  computed: {
    ...mapState('notification', ['snackbar']),

    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light'
    },

    ...mapState('locale', ['locales']),

    ...mapGetters('account', ['isAuthenticated', 'isBooting'])
  },

  beforeCreate() {
    if (checkBrowser.isIE()) {
      this.$router.push('./update-browser')
    }

    this.$axios.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.response && error.response.status === 401) {
          this.$router.push('/error')
        } else {
          // alert(error)
        }
        return Promise.reject(error)
      }
    )
  },

  async created() {
    try {
      await this.getAvailableLocales()
      await loadLanguage()
      this.isLoading = false
    } catch (e) {
      console.error(e)
    }
  },

  methods: {
    ...mapActions('locale', ['getAvailableLocales'])
  }
}
</script>

<style lang="scss">
@import './sass/app.scss';

.loader-page {
  position: absolute;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
</style>
